import { render } from "./EnbProduto.vue?vue&type=template&id=454c7ffc&scoped=true"
import script from "./EnbProduto.vue?vue&type=script&lang=js"
export * from "./EnbProduto.vue?vue&type=script&lang=js"

import "./EnbProduto.vue?vue&type=style&index=0&id=454c7ffc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454c7ffc"]])

export default __exports__